/** ### Font Weight Tokens
 * ---
 * There are three font-weight tokens.
 * Each token name maps to the weight name, and each value is a number.
 *
 * - regular (400)
 * - medium (500)
 * - bold (700)
 *
 * @example
 * ```tsx
 * import { type } from '@workday/canvas-kit-react/tokens';
 *
 * const BoldText = () => (
 *   <p css={{fontWeight: type.properties.fontWeights.bold}>
 *     Bold Text
 *   </p>
 * );
 * ```
 */
export const fontWeights = {
    regular: 400,
    medium: 500,
    bold: 700,
};
